import { en } from './en';

const da = {
  cta: {
    contactSupport: 'Kontakt support',
    downloadLabel: 'Download label',
    postponeDelivery: 'Udskyd levering',
    postponePickup: 'Udskyd levering',
  },
  language: {
    label: 'Sprog',
  },
  driverBox: {
    cancelledBooking: 'Aflyst booking',
    deliveredTo: 'Din ordre er blevet leveret',
    driver: 'Chauffør',
    expectedPickup: 'Forventet afhentning: {{date}}',
    internalTransit: 'Intern transport mellem depoter',
    notFound: 'Ikke fundet',
    packageReceivedBy: 'Din pakke blev modtaget af:',
    registered: 'Registreret',
    shipmentPostponed: 'Forsendelse blev udskudt',
    yourDriver: 'Din chauffør:',
  },
  progress: {
    arrivingSoonLine1: 'Ankommer',
    arrivingSoonLine2: 'snart',
    outForDeliveryLine1: 'Ude til',
    outForDeliveryLine2: 'levering',
    outForPickupLine1: 'På vej til',
    outForPickupLine2: 'afhentning',
  },
  requirements: {
    acceptAndContinue: 'Acceptér og fortsæt',
    accepting: 'Accepterer...',
    acceptError: 'Kunne ikke acceptere vilkår. Prøv igen.',
    checkboxLabel: 'Jeg bekræfter, at jeg har læst og forstået disse krav.',
    intro: 'Bekræft venligst, at du har læst og forstået følgende krav:',
    items: [
      'Enheden skal demonteres og tages ned inden afhentning.',
      'Beslag, fødder og tilbehør skal fjernes fra enheden.',
      'Hvis din enhed inkluderer en One Connect Box, skal den sendes sammen med produktet og One Connect-kablet.',
      'Vores chauffør kan ikke håndtere TV over 55" alene.',
      'Sørg for, at din forsendelseslabel er udskrevet inden afhentningsdatoen.',
    ],
    title: 'Før vi kan afhente din enhed',
  },
  reschedule: {
    calendarDays: ['SØN', 'MAN', 'TIR', 'ONS', 'TOR', 'FRE', 'LØR'],
    calendarMonths: [
      'JANUAR',
      'FEBRUAR',
      'MARTS',
      'APRIL',
      'MAJ',
      'JUNI',
      'JULI',
      'AUGUST',
      'SEPTEMBER',
      'OKTOBER',
      'NOVEMBER',
      'DECEMBER',
    ],
    confirmingDate: 'Vi bekræfter din nye {{mode}}dato.',
    delivery: 'levering',
    deliveryNoDates:
      'Leveringsdato kan ikke ændres — ingen datoer tilgængelige.',
    errorBody1:
      'Vi stødte på en uventet fejl under behandlingen af din anmodning. Din forsendelse forbliver planlagt som normalt.',
    errorBody2:
      'Prøv venligst at indsende din nye dato igen. Hvis problemet fortsætter, kan vores supportteam hjælpe dig med at omlægge manuelt.',
    errorTitle: 'Din forsendelse blev ikke opdateret.',
    footerConfirmed:
      'Når din nye dato er bekræftet, modtager du både e-mail og SMS med de opdaterede afhentnings- eller leveringsoplysninger.',
    footerHeadsUp:
      'Det er ikke altid muligt at udskyde, hvis en chauffør allerede er på vej til dig.',
    footerHeadsUpLabel: 'Bemærk:',
    footerOnceConfirmedLabel: 'Når din nye dato er bekræftet,',
    loadDatesError: 'Kunne ikke indlæse tilgængelige datoer. Prøv igen.',
    loadingDates: 'Indlæser tilgængelige {{mode}}datoer...',
    pickup: 'afhentnings',
    pickupNoDates:
      'Afhentningsdato kan ikke ændres — ingen datoer tilgængelige.',
    previousDate: 'Tidligere {{mode}}dato:',
    retry: 'Prøv igen',
    successMessage: 'Din nye forsendelsesdato er {{date}}.',
    successMessageWithWindow:
      'Din nye forsendelsesdato er {{date}}, med et tidsvindue på {{window}}.',
    successTitle: 'Din forsendelse er blevet opdateret.',
    timeFrame: 'Tidsrum',
    title: 'Omlæg din forsendelse',
    tryAgain: 'Prøv igen',
    updateShipment: 'Opdater din forsendelse',
    updating: 'Opdaterer din forsendelse...',
  },
  timeline: {
    arrivedAtDepot: 'Forsendelse ankom til depot',
    arrivedAtDepotDesc: 'Vi modtog din ordre på vores depot:',
    arrivingShortly: 'Vi er hos dig inden længe!',
    bookingRegistered: 'Din booking er registreret i vores system.',
    cancelled: 'Din ordre er blevet annulleret',
    cancelledOn: 'Din ordre blev annulleret den',
    delivered: 'Din ordre er blevet leveret.',
    deliveredAt: 'Vi leverede din ordre kl.',
    departedDepot: 'Forsendelse forlod vores depot',
    departedDepotDesc: 'Din forsendelse forlod vores depot:',
    driverEnRoute: 'Vores chauffør er på vej til dig.',
    driverEnRouteWithEta: 'Vores chauffør er på vej til dig. ETA {{eta}}.',
    furtherUpdates: 'Yderligere opdateringer kommer snart.',
    orderCancelled: 'Din ordre er blevet annulleret',
    orderDelivered: 'Din ordre er blevet leveret.',
    orderPickedUp: 'Din ordre er blevet afhentet.',
    orderPickedUpTitle: 'Din ordre er blevet afhentet',
    orderRegisteredOn: 'Din ordre blev registreret den',
    outForDelivery: 'Ude til levering!',
    outForPickup: 'På vej til afhentning!',
    outForPickupEnRoute:
      'På vej til afhentning! Vores chauffør er på vej til dig.',
    pickedUpOn: 'Din ordre blev afhentet den',
    pickedUpOnAt: 'Din ordre blev afhentet den',
    receivedAt: 'Vi modtog din ordre kl.',
    registered: 'Registreret',
    shipmentArrivedAtDepot: 'Forsendelse ankom til depot:',
    thereShortly: 'Vi er der inden længe!',
    at: 'kl.',
    bookingChanged: 'Din booking er blevet ændret',
    orderPostponedFor: 'Din ordre blev udskudt til',
  },
  home: {
    faqTitle: 'Ofte stillede spørgsmål',
    faqs: [
      {
        answer:
          'Indtast dit trackingnummer i søgefeltet ovenfor for at se opdateringer i realtid, herunder seneste status og placering. Du kontaktes også af chaufføren, når de er tæt på din leveringsadresse.',
        question: 'Hvordan tracker jeg min forsendelse?',
      },
      {
        answer:
          'Den estimerede leveringsdato vises i dine trackingdetaljer. Leveringer foregår normalt i standard arbejdstiden (9–18).',
        question: 'Hvornår ankommer min forsendelse?',
      },
      {
        answer:
          'Tjek først nummeret for stavefejl. Hvis det er korrekt, er din forsendelse måske endnu ikke scannet ind i systemet. Prøv igen senere.',
        question: 'Mit trackingnummer virker ikke. Hvad gør jeg?',
      },
      {
        answer:
          'Ja, du kan anmode om at udskyde afhentning eller levering via mulighederne på tracking-siden eller linket i SMS’en. Har du problemer, hjælper vores support gerne.',
        question: 'Kan jeg udskyde min levering?',
      },
    ],
    features: {
      live: 'Live statusopdateringer',
      map: 'Chauffør på kortet',
      reschedule: 'Udskyd levering',
    },
    searchCta: 'Spor forsendelse',
    searchLabel: 'Trackingnummer',
    searchPlaceholder: 'Indtast trackingnummer',
    searchTitle: 'Find din forsendelse',
    subtitle:
      'Indtast dit trackingnummer for at se live status, chaufførens placering og leveringsdetaljer.',
    title: 'Spor din forsendelse',
  },
  trackSection: {
    info: 'Detaljer',
    status: 'Status',
  },
  shipmentDetails: {
    addresses: 'Rute',
    contentsCount: 'Indhold',
    courier: 'Kurer',
    eyebrow: 'Detaljer',
    noEvents: 'Ingen hændelser registreret endnu.',
    orderHistory: 'Ordrehistorik',
    orderHistoryHint: '{{count}} hændelser',
    overview: 'Overblik',
    pickupDate: 'Afhentningsdato',
    recipient: 'Modtager',
    reference: 'Reference',
    sender: 'Afsender',
    title: 'Forsendelsesdetaljer',
  },
  notFound: {
    backHome: 'Tilbage til forsiden',
    code: '404',
    pageDescription: 'Siden du leder efter, findes ikke.',
    pageTitle: 'Side ikke fundet',
    trackingDescription:
      'Dette trackingnummer blev ikke fundet eller er ikke længere tilgængeligt.',
    trackingTitle: 'Tracking ikke fundet',
  },
};

export { da };
